import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import createDragViewState from 'owa-dnd/lib/utils/createDragViewState';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    onFavoriteParsingComplete,
    type ON_FAVORITES_ParsingCompleteActionMessage,
} from 'owa-favorites';

export const onFavoriteParsingCompleteMutator: (
    actionMessage: ON_FAVORITES_ParsingCompleteActionMessage
) => void = mutator(onFavoriteParsingComplete, actionMessage => {
    if (isGlobalFeatureEnabled('fp-viewstate-fix')) {
        for (const favoriteId of actionMessage.favoriteIds) {
            if (!getStore().favoriteNodeViewStates.has(favoriteId)) {
                getStore().favoriteNodeViewStates.set(favoriteId, {
                    drag: createDragViewState(),
                    drop: createDropViewState(),
                });
            }
        }
    }
});
